var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.description)+" "),_c('i',{class:("fal fa-" + _vm.icon)})])}
var staticRenderFns = []

export { render, staticRenderFns }